//import logo from "./logo.svg";
import { useState } from "react";
import { Button, Col, Row, Card, Input, Select } from "antd";
import { query } from "./../generate";
const { TextArea } = Input;

function Main() {
  const [inputText, setInputText] = useState('');
  const [resultText, setResultText] = useState('');
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState('Proposal');
  const [model, setModel] = useState('davinchi');
  const handleChange = (value) => {
    setMode(value);
    console.log(`selected ${value}`);
  };
  const handleModelChange = (value) => {
    setModel(value);
    console.log(`selected ${value}`);
  };
  function generatePrompt(query) {
    if (mode === "Proposal")
      return `This is job post:
   ${query}.
  Write a job proposal for applying this job in detail with timeline and solution. 2000 words.
  I'm an individual developer. I can work for 40 hours per week.
  `;
    else if(mode==='Quering')
      return `${query} ?
  Answer in detail 2000 words :`;
  else 
    return `This is a message from job interview:${query}
  Answer :
  I'm very confident in your project.`;
  }
  const handleRunClick = async () => {
    setLoading(true);
    const result = await query({
      prompt: generatePrompt(inputText),
      model: model === "davinchi" ? "text-davinci-003" : `text-${model}-001`,
    });
    setResultText(result);
    setLoading(false);
  };
  return (
    <Col align="center">
      <Card title="Super AI Text Generator" bordered={false} style={{ width: "90%" }}>
        <Row align="right">
          <Col style={{ padding: 5 }}>
            <Select
              defaultValue="Proposal"
              style={{
                width: 120,
              }}
              onChange={handleChange}
              options={[
                {
                  value: "Proposal",
                  label: "Proposal",
                },
                {
                  value: "Interview",
                  label: "Interview",
                },
                {
                  value: "Quering",
                  label: "Quering",
                },
              ]}
            />
          </Col>
          <Col style={{ padding: 5 }}>
            <Select
              defaultValue="Davinchi"
              style={{
                width: 120,
              }}
              onChange={handleModelChange}
              options={[
                {
                  value: "davinchi",
                  label: "Davinchi",
                },
                {
                  value: "ada",
                  label: "Ada",
                },
                {
                  value: "curie",
                  label: "Curie",
                },
                {
                  value: "babbage",
                  label: "Babbage",
                },
              ]}
            />
          </Col>
          <Col style={{ padding: 5 }}>
            <Button onClick={handleRunClick} loading={loading}>
              {loading ? "Loading..." : "Generate"}
            </Button>
          </Col>
        </Row>
        <Row>
          <Col span={12} style={{ padding: 5 }}>
            <TextArea
              rows={24}
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
            />
          </Col>
          <Col span={12} style={{ padding: 5 }}>
            <TextArea
              rows={24}
              placeholder="Content"
              value={resultText}
              onChange={(e) => setResultText(e.target.value)}
            />
          </Col>
        </Row>
      </Card>
    </Col>
  );
}

export default Main;
